// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
let RivalIQ;
if (typeof window === 'undefined') {

    RivalIQ = {
        enums: {}
    };

    module.exports = RivalIQ.enums;
} else {
    RivalIQ = window.RivalIQ;
    RivalIQ.module('enums', function () {});
}

(function (enums) {
    'use strict';

    enums.audit = {
        actions: {
            create_landscape: {
                id: 1
            },
            delete_landscape: {
                id: 2
            },
            add_company: {
                id: 3
            },
            remove_company: {
                id: 4
            },
            subscribe: {
                id: 5
            },
            change_plan: {
                id: 6
            },
            resubscribe: {
                id: 7
            },
            churn: {
                id: 8
            },
            update_billing: {
                id: 9
            },
            create_user: {
                id: 10
            },
            delete_user: {
                id: 11
            },
            payment_failed: {
                id: 12
            },
            payment_settled: {
                id: 13
            },
            delete_configuration: {
                id: 14
            },
            update_token: {
                id: 15
            },
            update_listening_saved_search: {
                id: 16
            },
            delete_listening_saved_search: {
                id: 17
            }
        }
    };
})(RivalIQ.enums);
